module.exports = __webpack_public_path__ + "assets/img/settings.14485d69.svg";